import { makeStyles } from 'tss-react/mui';

import { GLOBAL_SNACKBAR_WIDGET_WIDTH_PX } from '~/components/GlobalSnackbarStack/constants';

/** Fixed bottom-right card width, matching the Figma toast (node 5832:162314). */
const TOAST_WIDTH = GLOBAL_SNACKBAR_WIDGET_WIDTH_PX;

const useStyles = makeStyles()((theme) => ({
  root: {
    // Positioning is owned by the shared GlobalSnackbarStack; this is a flow
    // child. As the bottom-most stack child it sits flush against the viewport
    // bottom, so only the top corners are rounded (Figma node 5832:162341).
    width: TOAST_WIDTH,
    maxWidth: `calc(100vw - ${theme.new.spacing.large} * 2)`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.new.spacing.medium,
    padding: theme.new.spacing.medium,
    backgroundColor: theme.new.color.grey[900],
    color: theme.new.color.common.white,
    borderTopLeftRadius: theme.new.shape.borderRadius.medium,
    borderTopRightRadius: theme.new.shape.borderRadius.medium,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    boxShadow: theme.new.boxShadows.elevation2,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.new.spacing.small,
  },
  title: {
    color: theme.new.color.common.white,
  },
  iconButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    color: theme.new.color.common.white,
    '& svg': { width: 16, height: 16 },
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.new.spacing.medium,
  },
  batchRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.new.spacing.xsmall,
  },
  startedAt: {
    color: theme.new.color.common.white,
  },
  progressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.new.spacing.small,
  },
  progressBar: {
    flex: 1,
    height: 4,
    borderRadius: 2,
  },
  countLabel: {
    color: theme.new.color.common.white,
    minWidth: 'fit-content',
  },
  completionRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.new.spacing.xsmall,
  },
  completionIcon: {
    width: 16,
    height: 16,
    flexShrink: 0,
    // successCircle.svg ships without a stroke color (unlike error.svg), so it
    // only renders when the parent supplies one.
    '& path': { stroke: theme.new.color.common.white },
  },
  completionText: {
    color: theme.new.color.common.white,
  },
  retryButton: {
    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    color: theme.new.color.common.white,
    textDecoration: 'underline',
    font: 'inherit',
    '&:disabled': {
      cursor: 'default',
      opacity: 0.6,
    },
  },
}));

export default useStyles;
